import React, { Fragment } from "react";
// import { FormattedMessage, injectIntl } from 'react-intl';
import config from "../../../src/globs/config";
import moment from "moment";
import classNames from "classnames";
import LoadingState from "../common/loading-state";
import PropTypes from "prop-types";
import FormattedCurrencyNumberCustom from "../formatted-currency-number-custom/";
import PayerRow from "../payer-row";
import PayerSelect from "../payer-select/container";
import BalanceDetails from "./balance-details";
import FrCMBalanceDetails from "./balance-details/fr-CM-balance";
import ContactUs from "./contactus.svg";
import FormattedNumberCustom from "../../util/formatted-number-custom";
import {getInstrumentedAxiosInstance } from '../../globs/ajax-proxy'

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import gaPush from "../../globs/utils/google-analytics";

const DAYS_DIFF = 14;

class CustomerOrder extends React.Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    dataLoad: PropTypes.func,
    clearFilter: PropTypes.func,
  };
  static defaultProps = {
    dataLoad: undefined,
    clearFilter: undefined,
  };

  state = {
    isHeaderVisible: true,
    openFilter: false,
    businessId: null,
    fromDate: this.props.fromDate,
    toDate: this.props.toDate,
    noDataForDuration: false,
    showMainLoader: false,
    showPayerBalance: false,
    typeValue: this.props.typeValue,
    loadMoreShow: true,
    ShowPayerPop: false,
    ShowBalancePopUp: false,
    currentFromDate: this.props.fromDate,
    currentToDate: this.props.toDate,
    isAppliedFilter: false,
    // salesOfficerId: null,
    shipTo: "",
    orderNumber: "",
    sdoNumber: "",
    orderStatus: "",
    shipToValidationError: false,
    orderNumberValidationError: false,
    sdoNumberValidationError: false,
    isAppliedFilter: false,
    complaintsNotificationsSystem:
      this.props.user.settings_data.ADMIN_PANEL_COMPLAINT_MGMT,
    isTradeDeveloper: this.props.user.is_trade_developer,
  };

  componentDidMount() {
    this.fireGaEventPagePath(window.location.pathname + window.location.search);
    // const customerOrders = this.props.customerOrders;
    const key = "filterOrders";
    if (this.props.customerOrders.length === 0) {
      this.getDigitalOrderList(key);
      this.setState({
        showMainLoader: true,
        // typeValue: 'startLoad',
      });
    }

    if (this.props.customerOrders.length < 1) {
      this.setState({
        noDataForDuration: true,
      });
      setTimeout(() => {
        this.setState({
          noDataForDuration: false,
        });
      }, 5000);
    }

    const { props } = this;
    const salesOfficerId = props.user.id;
    this.setState({
      businessId: this.props.match.params.customerId,
      // salesOfficerId:props.user.id
    });

    const fetch_customer_url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${this.props.match.params.customerId}`;
    props.dataLoad({
      key: "customer",
      url: fetch_customer_url,
    });

    const fetch_balance_url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${this.props.match.params.customerId}/fetch_balance`;
    props.dataLoad({
      key: "balance",
      url: fetch_balance_url,
    });

    const path_ = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${this.props.match.params.customerId}/get_loyalty_points`;
    getInstrumentedAxiosInstance().get(path_)
    .then((res) => {
      console.log('loyality pts',res)
    })
    .catch((err) => console.log(err))
  }

  componentDidUpdate(prevProps, prevState) {
    const { props } = this;
    // Only update when API status changes from PENDING to complete
    // Add guards to prevent infinite loops in React 19
    if (
      prevProps.ajaxStatuses.customer === "PENDING" &&
      props.ajaxStatuses.customer === ""
    ) {
      // Only update if showMainLoader needs to change
      if (this.state.showMainLoader !== false) {
        this.setState({
          showMainLoader: false,
        });
      }
      this.fireGaEvent(
        "TrackOrder",
        "TotalOrders",
        `${this.props.customer.total_orders}`
      );
      this.fireGaEvent(
        "TrackOrder",
        "LROrders",
        `${this.props.customer.app_orders}`
      );
    }
    if (
      (prevProps.ajaxStatuses.orders === "PENDING" &&
        props.ajaxStatuses.orders === "") ||
      (prevProps.ajaxStatuses.filterOrders === "PENDING" &&
        props.ajaxStatuses.filterOrders === "")
    ) {
      const noMoreData =
        this.props.customerOrders.length === prevProps.customerOrders.length;
      const newNoDataForDuration = props.customerOrders.length === 0;

      // Only update if state actually needs to change
      if (this.state.showMainLoader !== false ||
          this.state.loadMoreShow !== true ||
          this.state.noDataForDuration !== newNoDataForDuration) {
        if (noMoreData) {
          this.setState(
            {
              showMainLoader: false,
              loadMoreShow: true,
              noDataForDuration: newNoDataForDuration,
            },
            () => {
              if (props.customerOrders.length === 0) {
                setTimeout(() => {
                  this.setState({
                    noDataForDuration: false,
                  });
                }, 4000);
              }
            }
          );
        } else {
          this.setState({
            showMainLoader: false,
            loadMoreShow: true,
            noDataForDuration: newNoDataForDuration,
          });
          setTimeout(() => {
            this.setState({
              noDataForDuration: false,
            });
          }, 4000);
        }
      }
    }
  }

  onOkClick = () => {
    this.setState({
      ShowPayerPop: false,
    });
  };

  // componentWillUnmount () {
  //     const { props } = this;
  //     props.clearFilter({
  //         key: 'clearFilter'
  //     });
  //   }

  getDigitalOrderList = (key) => {
    const { props } = this;
    const salesOfficerId = props.user.id;

    const dateFrom1 = moment
      .parseZone(this.state.fromDate)
      .locale("en")
      .format("YYYY-MM-DD");
    const dateFrom2 = moment
      .parseZone(this.state.toDate)
      .locale("en")
      .format("YYYY-MM-DD");
    let path_ = "";

    if (this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isSap") {
      // `${props.user._links.sap_digital_orders.href}?fromDate=${dateFrom1}&toDate=${dateFrom2}&loadType=${this.state && this.state.typeValue}&ship_to=${this.state && this.state.shipTo}&order_number=${this.state && this.state.orderNumber}&sdo_number=${this.state && this.state.sdoNumber}`;
      path_ = `${
        config.apiContextPath
      }/sales_officers/${salesOfficerId}/businesses/${
        this.props.match.params.customerId
      }/sap_digital_orders?fromDate=${
        this.state && this.state.fromDate
      }&toDate=${this.state && this.state.toDate}&loadType=${
        this.state && this.state.typeValue
      }&ship_to=${this.state && this.state.shipTo}&order_number=${
        this.state && this.state.orderNumber
      }&sdo_number=${this.state && this.state.sdoNumber}&order_status=${
        this.state && this.state.orderStatus
      }`;
    } else if (dateFrom1 && dateFrom2) {
      // path_ = `${props.user._links.sap_digital_orders.href}?pageNo=${this.state.pageNo}&fromDate=${dateFrom1}&toDate=${dateFrom2}&loadType=${this.state && this.state.typeValue}`;
      path_ = `${
        config.apiContextPath
      }/sales_officers/${salesOfficerId}/businesses/${
        this.props.match.params.customerId
      }/sap_digital_orders?fromDate=${
        this.state && this.state.fromDate
      }&toDate=${this.state && this.state.toDate}&loadType=${
        this.state && this.state.typeValue
      }`;
    } else {
      // path_ = `${props.user._links.sap_digital_orders.href}?pageNo=${this.state.pageNo}`;
      path_ = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${this.props.match.params.customerId}/sap_digital_orders`;
    }

    // const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses/${this.props.match.params.customerId}/sap_digital_orders?fromDate=${this.state && this.state.fromDate}&toDate=${this.state && this.state.toDate}&loadType=${this.state && this.state.typeValue}`;
    props.dataLoad({
      key: key,
      url: path_,
    });
  };

  onBackButtonEvent = (e) => {
    e.preventDefault();
    return false;
  };

  fetchMoreData = () => {
    const key = "orders";
    this.setState({
      showMainLoader: true,
      loadMoreShow: false,
    });
    const DAYS_DIFF = 14;
    const fromDate = moment(this.props && this.props.fromDate)
      .subtract(DAYS_DIFF, "d")
      .format("YYYY-MM-DD");
    this.setState(
      {
        //   isLoading: true,
        fromDate,
        toDate: moment(this.props && this.props.fromDate).format("YYYY-MM-DD"),
        typeValue: "loadMore",
        //   noDataForDuration: false,
      },
      () => {
        this.fireGaEvent(
          "TrackOrder",
          "LoadMoreClicked",
          `From ${this.state.fromDate} to ${this.state.toDate}`
        );
        this.getDigitalOrderList(key);
      }
    );
    setTimeout(() => {
      this.setState({
        noDataForDuration: false,
      });
    }, 4000);
  };

  goToTonnage = () => {
    this.fireGaEvent(
      "TrackOrder",
      "TonageReportClicked",
      `${this.props.match.params.customerSapCode}`
    );
    this.props.history.push(`/tonnage-report/${this.state.businessId}`);
  };

  goToPaymentInvoice = () => {
    this.props.history.push(`/statement/${this.state.businessId}`);
  };

  goToLoyalty = () => {
    this.props.history.push(`/loyalty/${this.state.businessId}`);
  };


  goToComplaints = () => {
    this.props.history.push(`/complaint-list/${this.state.businessId}`);
  };

  // showPayerBalance = () => {
  //     this.setState({
  //         showPayerBalance: true
  //     });
  // }

  showPayerBalanceList = () => {
    this.setState({
      ShowPayerPop: true,
    });
    // const { props } = this;
    // this.props.customer.business && this.props.customer.business.payers.forEach((payer) => {
    //     const path = `${config.apiContextPath}/sales_officers/${this.props.user.id}/businesses/${this.props.customer.business.id}/fetch_balance?payer_sap_code=${payer.payer_sap_code}`;
    //     props.dataLoad({
    //         key: 'payers',
    //         url: path,
    //     });
    // });
  };

  orderDetailsPage = (order) => {
    this.fireGaEvent(
      "TrackOrder",
      "OrderDetailsClicked",
      `${order.logon_customer_order_number}`
    );
    this.fireGaEvent(
      "TrackOrder",
      "OrderStatus",
      order.customero_order_status_description
    );
    this.props.history.push({
      pathname: `/order-detail/${this.state.businessId}/${order.logon_customer_order_number}`,
      search:
        this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isJDE"
          ? `?plant_code=${order.plant_code}`
          : this.props.user.locale === "en-ZW"
          ? `?creation_date=${order.creation_date}`
          : null,
    });
  };

  backPage = () => {
    const { props } = this;
    props.clearFilter({
      key: "clearFilter",
    });
    this.props.history.push("/customer-list");
  };

  opneFilter = () => {
    this.setState({
      openFilter: true,
    });
  };

  applyFilter = (filterKey) => {
    const key = "filterOrders";
    // this.setState({
    //     typeValue: 'filterByDate'
    // })
    if (
      this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isSap" &&
      (this.state.shipToValidationError ||
        this.state.orderNumberValidationError ||
        this.state.sdoNumberValidationError)
    ) {
      console.log("in sap condition");
    } else {
      this.setState(
        {
          showMainLoader: true,
          openFilter: false,
          typeValue: filterKey,
          isAppliedFilter: true,
        },
        () => {
          this.fireGaEvent(
            "TrackOrder",
            "FilterApplied",
            `From ${this.state.fromDate} to ${this.state.toDate}`
          );
          this.getDigitalOrderList(key);
        }
      );
    }

    if (this.props.customerOrders.length < 1) {
      this.setState({
        noDataForDuration: true,
      });
      setTimeout(() => {
        this.setState({
          noDataForDuration: false,
        });
      }, 5000);
    }

    // this.setState({
    //     showMainLoader: true,
    //     openFilter: false,
    //     typeValue: filterKey,
    //     isAppliedFilter:true,

    // }, () => {
    //     this.fireGaEvent('TrackOrder', 'FilterApplied', `From ${this.state.fromDate} to ${this.state.toDate}`);
    //     this.getDigitalOrderList(key);
    // });

    // this.getDigitalOrderList(key);
    this.setState({
      openFilter: false,
    });
  };

  resetFilter = () => {
    // const key = 'orders'
    if (this.props.customerOrders.length > -1) {
      this.setState({
        noDataForDuration: true,
      });
      setTimeout(() => {
        this.setState({
          noDataForDuration: false,
        });
      }, 5000);
    }
    // this.props.history.push(`/customer-orders/${this.props.match.params.customerId}/${this.props.match.params.customerSapCode}/${this.props.match.params.customerName}`);

    const fromDate = moment().subtract(7, "d").format("YYYY-MM-DD");
    const toDate = moment().add(7, "d").format("YYYY-MM-DD");
    this.setState(
      {
        fromDate,
        toDate,
        // openFilter: false,
        // showMainLoader: true,
        shipTo: "",
        orderNumber: "",
        sdoNumber: "",
        orderStatus: "",
        shipToValidationError: false,
        orderNumberValidationError: false,
        sdoNumberValidationError: false,
        isAppliedFilter: false,
      }
      // () => {
      //     this.applyFilter(resetKey);
      // }
    );
  };

  onBackButtonEvent = () => {
    this.setState({
      openFilter: false,
    });
  };

  handleDateChangefrom = (val) => {
    const dayDiff = moment(this.state.toDate).diff(val, "days");
    const newToDefault =
      dayDiff > DAYS_DIFF
        ? moment(val).add(DAYS_DIFF, "d").format("YYYY-MM-DD")
        : this.state.toDate;
    const val1 = moment(val).format("YYYY-MM-DD");
    this.setState({
      fromDate: val1,
      toDate: newToDefault,
    });
  };

  handleDateChangeto = (val) => {
    const dayDiff = moment(val).diff(this.state.fromDate, "days");
    const newFromDefault =
      dayDiff > DAYS_DIFF
        ? moment(val).subtract(DAYS_DIFF, "d").format("YYYY-MM-DD")
        : this.state.fromDate;
    const val1 = moment(val).format("YYYY-MM-DD");
    this.setState({
      fromDate: newFromDefault,
      toDate: val1,
    });
  };

  fireGaEventPagePath = (path) => {
    gaPush("pageview", {
      path,
    });
  };

  fireGaEvent = (act, action, labelIn) => {
    const label = `${labelIn}`;
    gaPush("event", {
      category: act,
      action,
      label,
    });
  };

  backButtonClick = () => {
    this.setState({
      ShowBalancePopUp: false,
    });
  };

  onShipTo = (e) => {
    e.preventDefault();
    if (this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isSap") {
      const isStart01 = new RegExp(/^(?=\d{10}$)0[1]\d{8,9}/).test(
        e.target.value
      );
      const isStart1 = new RegExp(/^(?=\d{9}$)1\d{8,9}/).test(e.target.value);
      console.log("s", e.target.value.length);
      if (isStart01 || isStart1 || e.target.value.length === 0) {
        this.setState({ shipToValidationError: false });
      } else {
        console.log("ou");
        this.setState({ shipToValidationError: true });
      }
    }
    this.setState({ shipTo: e.target.value });
  };

  onOrderNumber = (e) => {
    e.preventDefault();
    if (this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isSap") {
      const isStart4 = new RegExp(/^(?=\d{8}$)4\d{7,8}/).test(e.target.value);
      if (isStart4 || e.target.value.length === 0) {
        console.log("ouxxx");
        this.setState({ orderNumberValidationError: false });
      } else {
        this.setState({ orderNumberValidationError: false });
      }
    }
    this.setState({ orderNumber: e.target.value });
  };

  onSdoNumber = (e) => {
    e.preventDefault();
    if (this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isSap") {
      this.setState({ sdoNumberValidationError: false });
      const isStart4 = new RegExp(/\d/).test(e.target.value);
      if (isStart4 || e.target.value.length === 0) {
        console.log("ouxxx");
        this.setState({ sdoNumberValidationError: false });
      } else {
        this.setState({ sdoNumberValidationError: true });
      }
    }
    this.setState({ sdoNumber: e.target.value });
  };

  changeOrderStatus = (e) => {
    e.preventDefault();
    this.setState({ orderStatus: e.target.value });
  };

  showUnitConditional = (order) => {
    const { props } = this;
    console.log("showUnitConditional====>", props.user.locale);
    if (order.order_total_tons.length > 0) {
      const qty =
        order.order_total_tons[0].uom_code ===
        order.order_total_tons[0].input_uom
          ? order.order_total_tons[0].sum
          : order.order_total_tons[0].sum /
            order.order_total_tons[0].conversion_factor;
      const convertQty =
        order.order_total_tons[0].uom_code ===
        order.order_total_tons[0].input_uom
          ? order.order_total_tons[0].sum *
            order.order_total_tons[0].conversion_factor
          : order.order_total_tons[0].sum;
      if (props.user.locale === "en-AE") {
        const orderQty = order.order_total_tons.reduce((a, b) => {
          return a + b.sum;
        }, 0);
        return (
          <span>
            <span>
              {" "}
              |{" "}
              <FormattedNumberCustom
                value={order.remaining_delivery_quantity}
              />
              /<FormattedNumberCustom value={orderQty} />{" "}
              {orderQty === 1
                ? order.order_total_tons[0].input_uom_name
                : order.order_total_tons[0].input_uom_name_plural}
            </span>
            {/* {
                            order.order_total_tons[0].show_conversion &&
                            <span> | <FormattedNumberCustom
                                value={convertQty}
                            /> {convertQty === 1 ?
                                order.order_total_tons[0].conversion_uom_name :
                                order.order_total_tons[0].conversion_uom_name_plural}
                            </span>
                        } {order.order_total_tons.length > 1 ? '...' : ''} */}
          </span>
        );
      }
      return (
        <span>
          <span>
            {" "}
            | <FormattedNumberCustom value={qty} />{" "}
            {qty === 1
              ? order.order_total_tons[0].input_uom_name
              : order.order_total_tons[0].input_uom_name_plural}
          </span>
          {order.order_total_tons[0].show_conversion && (
            <span>
              {" "}
              | <FormattedNumberCustom value={convertQty} />{" "}
              {convertQty === 1
                ? order.order_total_tons[0].conversion_uom_name
                : order.order_total_tons[0].conversion_uom_name_plural}
            </span>
          )}{" "}
          {order.order_total_tons.length > 1 ? "..." : ""}
        </span>
      );
    }
    return <span />;
  };

  render() {
    console.log("order props", this.props);
    let showPayer =
      this.props.customer.business &&
      this.props.customer.business.payers.length > 0;
    if (showPayer) {
      if (this.props.customer.business.payers.length === 1) {
        showPayer =
          this.props.customer.business.payers[0].payer_sap_code !==
          this.props.customer.business.sap_code;
      }
    }
    const showBalancePop =
      this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isJDE";
    const customerOrders = this.props.customerOrders;
    const classes = {
      view: classNames("lr-make-sale lr-overlay", {}),
    };
    const customer = this.props.customer;
    let balance = 0;
    let ordersNotInvoiced = 0;
    if (
      this.props.user.settings_data.DIGITAL_ORDER_SYSTEM === "isJDE" &&
      this.props.user.locale === "fr-CM"
    ) {
      balance = this.props.balance.removal_capacity;
      ordersNotInvoiced = Math.round(
        this.props.balance.sales_orders_not_invoiced *
          (1 + this.props.balance.tax_rate / 100)
      );
    } else {
      balance =
        this.props.balance && this.props.balance.sap_digital_order_balance
          ? this.props.balance.sap_digital_order_balance
          : 0;
      ordersNotInvoiced =
        this.props.balance && this.props.balance.orders_not_invoiced_price
          ? this.props.balance.orders_not_invoiced_price
          : 0;
    }
    return (
      <div>
        {this.state.ShowPayerPop && (
          <PayerSelect rowComponent={PayerRow} onOkClick={this.onOkClick} />
        )}
        {this.state.ShowBalancePopUp &&
          this.state.ShowBalancePopUp &&
          this.props.user.locale !== "fr-CM" && (
            <BalanceDetails
              dataLoad={this.props.dataLoad}
              ajaxStatuses={this.props.ajaxStatuses}
              match={this.props.match}
              balance={this.props.balance}
              user={this.props.user}
              backButtonClick={this.backButtonClick}
            />
          )}
        {this.state.ShowBalancePopUp && this.props.user.locale === "fr-CM" && (
          <FrCMBalanceDetails
            dataLoad={this.props.dataLoad}
            ajaxStatuses={this.props.ajaxStatuses}
            match={this.props.match}
            balance={this.props.balance}
            user={this.props.user}
            backButtonClick={this.backButtonClick}
          />
        )}
        <div className="lr-main-view__header">
          <button
            type="button"
            className="lr-main-view__header-title"
            onClick={this.backPage}
          >
            <span className="icon-back"></span>
            <span>Track orders</span>
          </button>
          {this.state.showMainLoader
            ? false
            : true && (
                // <i className="icon-filter" onClick={this.opneFilter} />
                (<button
                  type="button"
                  onClick={this.opneFilter}
                  className={`icon-filter ${
                    this.state.isAppliedFilter &&
                    (this.state.currentFromDate !== this.state.fromDate ||
                      this.state.toDate !== this.state.selectedYear)
                      ? "filter-active"
                      : ""
                  }`}
                />)
              )}
        </div>
        <div className={this.state.showMainLoader ? "page-body-invisible" : ""}>
          <div className="customer-id-name-container">
            <div className="customer-id-name">
              <span>
                Customer:
                {this.props.customer.business
                  ? this.props.customer.business.sap_code
                  : ""}
              </span>
              <span>
                {this.props.customer.business
                  ? this.props.customer.business.name
                  : ""}
              </span>
            </div>
            {this.props.user.settings_data.SHOW_CONTACT_US &&
              this.state.complaintsNotificationsSystem && !this.state.isTradeDeveloper && (
                <button
                  className="contactus-button"
                  onClick={() => this.goToComplaints()}
                >
                  <img
                    className="contactus-icon"
                    src={ContactUs}
                    alt="ContactUs"
                  />
                </button>
              )}
          </div>
          {!this.state.isTradeDeveloper &&
            <div className="balance-invoice">
              {/* <div className="open-payers-icon">
                              <div className="open-payers-icon-div" onClick={() => this.ShowBalancePopUp()} >.</div>
                          </div> */}
              <div className="amount-details">
                <span>Balance</span>
                {/* {
                                  this.state.ShowBalancePopUp &&
                              <BalanceDetails
                              dataLoad={this.props.dataLoad}
                              ajaxDataLoadStatuses={this.props.ajaxDataLoadStatuses}
                              businessId={this.state.businessId}
                              salesOfficerId={this.state.salesOfficerId}
                              user={this.props.user}
                              backButtonClick={this.backButtonClick}
                              />
                              } */}
                <span>
                  <FormattedCurrencyNumberCustom
                    value={
                      balance ? balance : 0
                      // this.props.balance.sap_digital_order_balance ?
                      // this.props.balance.sap_digital_order_balance : 0
                    }
                    currency={this.props.balance.currency}
                  />
                </span>
              </div>
              {/* <img src={OpenPayers} alt="Open-Payers" onClick={() => this.showPayerBalance()} /> */}
              {showPayer && (
                <div className="open-payers-icon">
                  <div
                    className="open-payers-icon-div"
                    onClick={() => this.showPayerBalanceList()}
                  >
                    .
                  </div>
                </div>
              )}
              {showBalancePop && (
                <div className="open-payers-icon">
                  <div
                    className="open-payers-icon-div"
                    onClick={() => {
                      this.setState({ ShowBalancePopUp: true });
                    }}
                  >
                    .
                  </div>
                </div>
              )}
              {this.props.user.locale !== "en-AE" && (
                <div className="amount-details">
                  <span>Orders not Invoiced</span>
                  <span>
                    <FormattedCurrencyNumberCustom
                      value={
                        ordersNotInvoiced ? ordersNotInvoiced : 0
                        // this.props.balance.orders_not_invoiced_price ?
                        // this.props.balance.orders_not_invoiced_price : 0
                      }
                      currency={this.props.balance.currency}
                    />
                  </span>
                </div>
              )}
            </div>
          }
          {this.props.user.settings_data.DIGITAL_ORDER_SYSTEM !== "isJDE" && (
            <div className="tonnage">
              <button onClick={() => this.goToTonnage()}>Tonnage Report</button>
            </div>
          )}
          {this.props.user.settings_data.DIGITAL_ORDER_SYSTEM !== "isJDE" && !this.state.isTradeDeveloper && (
            <div className="tonnage">
              <button onClick={() => this.goToPaymentInvoice()}>
                Payments & Invoices
              </button>
            </div>
          )}       
          <div className="tonnage">
              <button onClick={() => this.goToLoyalty()}>
                Loyalty
              </button>
            </div>
          <div className="tonnage">
            <div className="appvstotal-orders">
              <span>{`${moment().format("MMMM")}:`}</span>
              <span>
                {/* {`${customer.app_orders ? `${customer.app_orders} App Orders / ` : ''}${customer.total_orders} Total Orders`} */}
                {`${customer.app_orders || 0} App Orders / ${
                  customer.total_orders || 0
                } Total Orders`}
              </span>
              {/* <span>20 App Orders / 50 Total Orders</span> */}
            </div>
          </div>
          {
            // this.props.user.settings_data.DIGITAL_ORDER_SYSTEM !== 'isJDE' &&
            //  customerOrders.sort((a, b) => moment(b.creation_date).diff(moment(a.creation_date))).map((order) => {
            customerOrders
              .sort(
                (a, b) =>
                  b.logon_customer_order_number - a.logon_customer_order_number
              )
              .map((order) => {
                let iconName = "";
                // console.log('status', order.customero_order_status_cd);
                if (
                  Number(order.customero_order_status_cd) === 1 ||
                  Number(order.customero_order_status_cd) === 0
                ) {
                  iconName = "icon-hour-glass";
                } else if (Number(order.customero_order_status_cd) === 2) {
                  iconName = "icon-truck_fast";
                } else if (Number(order.customero_order_status_cd) === 3) {
                  iconName = "icon-tick";
                } else if (Number(order.customero_order_status_cd) === 4) {
                  iconName = "icon-cancel-order";
                }

                return (
                  <div
                    className="order-container"
                    key={order.logon_customer_order_number}
                  >
                    <div
                      className={`order ${
                        order.customero_order_status_cd === 4
                          ? "cancel-order-icon"
                          : ""
                      }`}
                      onClick={() => this.orderDetailsPage(order)}
                    >
                      <i className={iconName} />
                      <div className="order-no-order-from">
                        <span>Order {order.logon_customer_order_number}</span>
                        {order.is_app_order && <span> | App order</span>}
                      </div>
                      <div className="order-date-ton-bag-delivery">
                        <span>
                          {moment
                            .parseZone(order.creation_date)
                            .format("DD.MM.YYYY")}
                        </span>
                        {this.showUnitConditional(order)}
                        <span>
                          {" "}
                          |{" "}
                          {order.mode_of_delivery === "delivered"
                            ? "Delivered"
                            : order.mode_of_delivery === "agency"
                            ? "Agency"
                            : "Self Collect"}
                        </span>
                      </div>
                      <div className="order-status">
                        <span>{order.customero_order_status_description}</span>
                        {order.customer_ref_number && (
                          <Fragment>
                            <span>
                              LPO:{" "}
                              {order.customer_ref_number
                                ? order.customer_ref_number
                                : "-"}
                            </span>
                          </Fragment>
                        )}
                      </div>
                      <i className="icon-arrow_right" />
                    </div>
                  </div>
                );
              })
          }
          {
            // this.props.user.settings_data.DIGITAL_ORDER_SYSTEM !== 'isJDE' &&
            !this.state.orderNumber && !this.state.sdoNumber && (
              <div className="loadmore">
                {!this.state.noDataForDuration
                  ? !this.state.showMainLoader &&
                    this.state.loadMoreShow && (
                      <button onClick={this.fetchMoreData}>load more</button>
                    )
                  : ""}
              </div>
            )
          }
          {this.state.noDataForDuration && (
            <div className="response-information-toaster">
              <div className="noorders-toaster">
                <span>No orders found between </span>
                <span>
                  {moment(this.props && this.state.fromDate).format(
                    "DD.MM.YYYY"
                  )}
                </span>
                <span> and </span>
                <span>
                  {moment(this.props && this.state.toDate).format("DD.MM.YYYY")}
                </span>
              </div>
            </div>
          )}
        </div>
        {this.state.openFilter && (
          <div className="filter-pop">
            <div className={classes.view}>
              {this.state.isHeaderVisible && (
                <div className="lr-overlay__header">
                  <div className="lr-overlay__header-title">
                    <button
                      type="button"
                      className="lr-overlay__header-back-button"
                      onClick={this.onBackButtonEvent}
                    >
                      <i className="icon-back" />
                    </button>
                    Filter Orders
                  </div>
                </div>
              )}
              <div className="lr-overlay__body order-detail">
                <div className="filter-content">
                  {this.props.user.settings_data.DIGITAL_ORDER_SYSTEM ===
                    "isJDE" ||
                  this.props.user.settings_data.DIGITAL_ORDER_SYSTEM ===
                    "isSageAPI" ? (
                    <h6>Select Order creation dates</h6>
                  ) : (
                    <h6>Select Delivery dates</h6>
                  )}
                  <div className="lr-text-input lr-input-row flexbox">
                    <div className="lr-label__customer-name">From Date</div>
                    <span className="lr-sale-overview-datemain">
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={this.state && this.state.fromDate}
                          onChange={this.handleDateChangefrom}
                          format="YYYY-MM-DD"
                          maxDate={this.state && this.state.toDate}
                        />
                      </LocalizationProvider>
                      <i className="icon-calender" />
                      <i className="icon-arrow_right" />
                    </span>
                  </div>
                  <div className="lr-text-input lr-input-row flexbox">
                    <div className="lr-label__customer-name">To Date</div>
                    <span className="lr-sale-overview-datemain">
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          value={this.state && this.state.toDate}
                          onChange={this.handleDateChangeto}
                          format="YYYY-MM-DD"
                          minDate={this.state && this.state.fromDate}
                        />
                      </LocalizationProvider>
                      <i className="icon-calender" />
                      <i className="icon-arrow_right" />
                    </span>
                  </div>
                  <h6>Order Status </h6>
                  <div className="lr-date-row">
                    <select
                      value={this.state.orderStatus}
                      onChange={this.changeOrderStatus}
                    >
                      <option
                        selected="selected"
                        value={""}
                        key={""}
                      >{`All`}</option>
                      {this.props.user.settings_data.MAIN_ORDER_STATUSES &&
                        this.props.user.settings_data.MAIN_ORDER_STATUSES.map(
                          (orderSts) => (
                            <option
                              selected="selected"
                              value={orderSts.value}
                              key={orderSts.value}
                            >
                              {orderSts.name}
                            </option>
                          )
                        )}
                    </select>
                  </div>
                  {this.props.user.settings_data.DIGITAL_ORDER_SYSTEM ===
                    "isSap" && (
                    <div className="search-order">
                      <h6>Ship To number</h6>
                      <div className="search-order-by">
                        <div className="icon-wrapper">
                          <i className="icon-search" />
                        </div>
                        <input
                          type="text"
                          placeholder="Enter Ship To number"
                          value={this.state.shipTo}
                          onChange={this.onShipTo}
                        />
                        {this.props.user.settings_data.DIGITAL_ORDER_SYSTEM ===
                          "isSap" && (
                          <p className="track-order-search-example">
                            (e.g., 0100631561 OR 100631561)
                          </p>
                        )}
                        {this.state.shipToValidationError && (
                          <p className="track-order-search-error">
                            Incorrect Ship To number
                          </p>
                        )}
                      </div>
                      <h6>Customer order number</h6>
                      <div className="search-order-by">
                        <div className="icon-wrapper">
                          <i className="icon-search" />
                        </div>
                        <input
                          type="text"
                          maxLength={30}
                          placeholder="Enter Customer order number"
                          value={this.state.orderNumber}
                          onChange={this.onOrderNumber}
                        />
                        {this.props.user.settings_data.DIGITAL_ORDER_SYSTEM ===
                          "isSap" && (
                          <p className="track-order-search-example">
                            (e.g., 41534907)
                          </p>
                        )}
                        {this.state.orderNumberValidationError && (
                          <p className="track-order-search-error">
                            Incorrect Customer order number
                          </p>
                        )}
                      </div>
                      <h6>Single delivery order number</h6>
                      <div className="search-order-by">
                        <div className="icon-wrapper">
                          <i className="icon-search" />
                        </div>
                        <input
                          type="text"
                          placeholder="Enter Single delivery order number"
                          value={this.state.sdoNumber}
                          onChange={this.onSdoNumber}
                        />
                        {this.props.user.settings_data.DIGITAL_ORDER_SYSTEM ===
                          "isSap" && (
                          <p className="track-order-search-example">
                            (e.g., 68788110)
                          </p>
                        )}
                        {this.state.sdoNumberValidationError && (
                          <p className="track-order-search-error">
                            Incorrect Single delivery order number
                          </p>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="flexbox btn-container">
                    <a
                      className="lr-button lr-button--primary  lr-orders__add-new-order-button"
                      onClick={() => this.resetFilter("startLoad")}
                    >
                      RESET
                    </a>
                    {/* <a className="lr-button lr-button--primary  lr-orders__add-new-order-button" onClick={() => this.applyFilter('filterByDate')}>APPLY</a> */}
                    <a
                      className={`${
                        this.props.user.settings_data.DIGITAL_ORDER_SYSTEM ===
                          "isSap" &&
                        (this.state.shipToValidationError ||
                          this.state.orderNumberValidationError ||
                          this.state.sdoNumberValidationError)
                          ? "apply-button-disable"
                          : ""
                      } lr-button lr-button--primary  lr-orders__add-new-order-button`}
                      onClick={() => this.applyFilter("filterByDate")}
                    >
                      APPLY
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.showMainLoader && (
          <div>
            <LoadingState />
            <div className="loadingContainer" />
          </div>
        )}
        {/* {
                    this.state.showPayerBalance &&
                    <div>
                        <div className="lr-customer-pop multiple-payers-pop">
                            <div className="lr-customer-pop__modal">
                                <div>
                                    <h2 className="lr-pop-heading"><span>Multiple Payers</span></h2>
                                    <form>
                                        <div className="multiple-payers"><span className="payer-name">ARAB CONTRACTORS O.A.O NIGERIA LTD
                        (0000258487)</span><button className="icon-refresh  "></button>
                                            <div className="balance-label"><span>My Balance</span><span>Orders not invoiced</span></div>
                                            <div className="balance-amount"><span><span className="custom-formated-currency"><span>NGN
                                    -49,909.91</span></span></span><span><span
                                                    className="custom-formated-currency"><span>NGN 2,164,768.04</span></span></span></div>
                                        </div>
                                        <div className="multiple-payers"><span className="payer-name">BABANGIDA MOHAMMED INTER LTD
                        (0000263170)</span><button className="icon-refresh  "></button>
                                            <div className="balance-label"><span>My Balance</span><span>Orders not invoiced</span></div>
                                            <div className="balance-amount"><span><span className="custom-formated-currency"><span>NGN
                                    0</span></span></span><span><span className="custom-formated-currency"><span>NGN
                                    0</span></span></span></div>
                                        </div>
                                    </form>
                                </div>
                                <div className="lr-button-row"><button><span><span>OK</span></span></button></div>
                            </div>
                        </div>
                    </div>
                }  */}
      </div>
    );
  }
}

export default CustomerOrder;
